import { Unsubscribe } from "redux";
import { getItem, setItem } from "~/es6/localstorage";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import { ELoginState, IUserState } from "~/state/user/interfaces";
import { watch, watchPremiumData } from "~/state/util";
import Dialog from "~/ui/dialog";
import { getPremiumIconSrc, node, text } from "~/util/dom";

export default class HoorayDialog {
	#dialog: Dialog;

	#storeUnsubscribe: Unsubscribe;

	constructor() {
		const { user } = store.getState();
		const wtUser = watch(store.getState, "user", watchPremiumData);

		this.#storeUnsubscribe = store.subscribe(wtUser(newUser => {
			this.#openIfValid(newUser);
		}));

		this.#openIfValid(user);
	}

	destroy() {
		this.#dialog.destroy();
		this.#storeUnsubscribe?.();
	}

	#openIfValid(user: IUserState) {
		const shown = getItem("hoorayShown");
		const shownArray: Array<number> = shown ? JSON.parse(shown) : [];
		const seen = shownArray.length ? shownArray.findIndex(item => item === user.user.rusId) > -1 : false;
		const isFreemium = user.user.premiumData.subscriptions?.length ? ["fanda", "admin"].includes(user.user.premiumData.subscriptions[0].subscriptionOrigin) : false;
		const recent = user.user.premiumData.subscriptions?.length
			? user.user.premiumData.subscriptions[0].purchaseDate
				? new Date(user.user.premiumData.subscriptions[0].purchaseDate).getTime() > new Date(Date.now() - 1209600000).getTime()
				: false
			: false;

		if (
			// uzivatel je prihlaseny
			user.user.state === ELoginState.Green
			// jeste v tomhle prohlizeci hura dialog nevidel
			&& !seen
			// ma freemium
			&& isFreemium
			// a ma to freemium mene nez 14 dnu
			&& recent
		) {
			const title = node("h1");
			const premium = node("strong");
			const doneButton = node("mapy-router-button", {}, _("hooray.goToMap"));

			doneButton.addEventListener("click", () => {
				this.#dialog.close();
			});
			premium.append(node("img", { src: getPremiumIconSrc(), crossOrigin: "anonymous" }), text(_("hooray.premium")));
			title.append(node("span", {}, _("hooray.unlock")), premium);
			this.#dialog = new Dialog({
				className: "hoorayDialog",
			});
			this.#dialog.dom.content.append(
				node("img", { src: "/img/profile/hooray.svg", crossOrigin: "anonymous" }),
				title,
				node("p", { innerHTML: _("hooray.thanks", { start: `<button>`, end: `</button>` }) }),
				doneButton,
			);
			this.#dialog.dom.content.querySelector("button")?.addEventListener("click", () => {
				this.#dialog.close();
				Mapy.getComponent("premiumStatus").activate();
			});
			this.#dialog.open();
			setItem("hoorayShown", JSON.stringify([...new Set([...shownArray, user.user.rusId])]));
		}
	}
}
